import Transformer from "./../transformer";
import roadConceptJB from "./../catalog/services/roadConceptJB";

class QuantificationConceptTransformer extends Transformer {
  static fetch(concept) {
    // :TODO: Rewrite transformer
    const cConcept = { ...concept, supplies: null, detail: 0 };
    const supplies = concept.supplies;
    let nConcept = roadConceptJB.fetch(cConcept);
    const quantityExecuted = +concept.quantity_executed;
    nConcept.quantityExecuted =
      quantityExecuted || quantityExecuted == 0
        ? +quantityExecuted.toFixed(6)
        : null;
    nConcept.concept = concept.concept;
    nConcept.quantity = +concept.quantity;
    nConcept.realQuantity = quantityExecuted;
    nConcept.servicesPrice = +concept.work_force;
    nConcept.materialsPrice = +concept.base_price;
    nConcept.showSupplies = false;
    nConcept.notToDo = concept.not_to_do;
    nConcept.cannotBeRepaired = concept.not_can_be_repaired;
    nConcept.internal_concept = concept.internal_concept;
    nConcept.supplies = supplies.map((supply) => {
      const supplyData = supply.supply.supply
        ? supply.supply.supply
        : supply.supply;
      const supplyName = supplyData.name;
      const supplyType = supplyData.supply_type.name;
      const unitMeasurement = supplyData.unit_measurement.name;
      const { is_active: isActive } = supply;
      const     extraQuantityPhysicalOut = supply.extra_output
          ? supply.extra_output.quantity_with_physical_out
          : "0"

      const allExtraRequests = supply.extra_output
          ? supply.extra_output.detail.map((d) => {
              return {
                status: d.detail_status,
                quantityRequested: d.quantity_requested,
                quantityPhysicalOut: d.quantity_physical_out,
                dateDeliveryComplete: d.date_delivery_complete,
              };
            })
          : ""
      const someUnfinishedExtraRequest = supply.extra_output
          ? supply.extra_output.detail
              .filter((r) => r.status_summary === "Pendiente")
              .map((r) => {
                return {
                  quantityRequested: r.quantity_requested,
                  currentStatus: r.status_summary,
                  quantityPhysicalOut: r.quantity_physical_out,
                  requisition: !!r.requisition && r.requisition.folio
                };
              })
          : []
      const lastextraAmountRequested = supply.extra_output
          ? supply.extra_output.detail[supply.extra_output.detail.length - 1]
              .quantity_requested
          : ""
      return {
        ...supply,
        isActive,
        dontUse: supply.dont_use,
        amount_to_request: +supply.amount_to_request,
        price: +supply.price,
        campPrice: +supplyData.camp_price,
        quantity: +supply.quantity,
        code: supplyData.code,
        returnAmount: 0,
        returnAmountMessage: "*Mensaje informativo de las devoluciones*",
        returnAmountStatus: supply.pending_re_entry,
        returnedAmount: supply.has_re_entry.entry,
        maxAmountToReturn: (+supply.has_re_entry.output - +supply.has_re_entry.entry).toFixed(6),
        returnRejectedMessage: supply.comment_reject,
        extraGeneralInfo: supply.extra_output,
        someUnfinishedExtraRequest,
        lastextraAmountRequested,
        allExtraRequests,
        extraAmount: 0,
        extraAmountMessage: "Se han pedido 10 piezas extra", // null si no tiene mensaje que mostrar
        extraQuantityPhysicalOut,
        supplyData,
        supplyTypeName: supply.supply_type,
        supplyName,
        supplyType,
        unitMeasurement,
        hasRequisition: supply.has_requisition
      };
    });
    const suppliesSum = nConcept.supplies
      .filter(({ dontUse }) => !dontUse)
      .reduce(
        (sum, supply) => supply.price * supply.amount_to_request + sum,
        0
      );
    nConcept.suppliesSum = suppliesSum;
    nConcept.subtotalSupplies = nConcept.suppliesSum * nConcept.quantity;
    nConcept.subtotal = nConcept.unitPriceMXN * nConcept.quantity;
    return nConcept;
  }
}

export { QuantificationConceptTransformer };

const forceNumber = (n) => (n ? +n : 0);

export default class QuantificationTransformer extends Transformer {
  static fetch(quantification) {
    const {
      workForcePrice,
      work_force_iva: workForceTax,
      workforce_total: workForceTotal,
      conceptsPrice,
      conceptsIVA: conceptsTax,
      concepts_total: conceptsTotal,
      total_to_pay: totalToPay,
      warehouse = {}
    } = quantification;

    const concepts= quantification.concepts.map(
        QuantificationConceptTransformer.fetch
      )
    const relatedOC = concepts.map(({supplies}) => supplies).flat().filter(({purchase_order}) => !!purchase_order).map(({purchase_order}) => purchase_order)
    return {
      id: quantification.id,
      addDate: quantification.add_date,
      clientPrice: +quantification.client_price,
      realPrice: +quantification.real_price,
      realClientPrice:
        +quantification.real_client_price ||
        +quantification.real_price ||
        +quantification.acenad_ammount,
      scopeClarification: quantification.scope_clarification,
      workForcePrice: forceNumber(workForcePrice),
      workForceTax: forceNumber(workForceTax),
      workForceTotal: forceNumber(workForceTotal),
      conceptsPrice: forceNumber(conceptsPrice),
      conceptsTax: forceNumber(conceptsTax),
      conceptsTotal: forceNumber(conceptsTotal),
      totalToPay: forceNumber(totalToPay),
      affected: quantification.affected,
      scope: quantification.scope,
      assistants: quantification.assistant_workers,
      flagWorkers: quantification.flag_workers,
      masters: quantification.master_workers,
      officials: quantification.official_workers,
      workedDays: +quantification.real_worked_days,
      avegareMWorkers: +quantification.average_master_workers || 0,
      avegareOWorkers: +quantification.average_official_workers || 0,
      avegareAWorkers: +quantification.average_assistant_workers || 0,
      avegareFWorkers: +quantification.average_flag_workers || 0,
      isAuthorized: quantification.authorized || false,
      closedByARe: quantification.project_closure_are,
      concepts,
      catalog: quantification.catalog,
      // relatedOC,
      relatedOC: [...new Set(relatedOC)],
      warehouse
    };
  }

  static send(quantification) {
    const concepts = quantification.concepts;
    const { deletedConcepts } = quantification;
    const data = {
      id: quantification.id || null,
      client_price: quantification.clientPrice,
      real_price: quantification.realPrice,
      affected: quantification.affected,
      scope: quantification.scope,
      flag_workers: quantification.flagWorkers,
      assistant_workers: quantification.assistants,
      master_workers: quantification.masters,
      official_workers: quantification.officials,
      concepts: concepts.map((concept) => ({
        ...concept,
        quantity: +concept.quantity,
        not_to_do: concept.notToDo,
        // concept: concept.id,
      })),
      catalog: quantification.catalog,
    };

    if (deletedConcepts) {
      data.deleted_concepts = deletedConcepts
        .filter(({ id }) => id > 0)
        .map(({ id }) => id);
    }

    return data;
  }
}



// WEBPACK FOOTER //
// ./src/transformers/purchase/quantification.js